export default __webpack_public_path__ + "static/media/valuation-banner.5706111c.png";